import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface PaneWithSidebarProps {
  children: React.ReactNode;
  sidebarExpanded: boolean;
  onToggleSidebarExpanded: () => void;
  sidebarContent: React.ReactNode;
}

export default function PaneWithSidebar({
  children,
  sidebarExpanded,
  onToggleSidebarExpanded,
  sidebarContent,
}: PaneWithSidebarProps): JSX.Element {
  return (
    <div className={css(styles.paneContainer)}>
      <div className={css(styles.sidebar, sidebarExpanded ? styles.expandedSidebar : null)}>
        <Button
          className={css(sidebarExpanded ? styles.expandToggle : null)}
          icon={sidebarExpanded ? 'chevron-left' : 'chevron-right'}
          size={ButtonSize.SMALL}
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          onClick={() => {
            onToggleSidebarExpanded();
          }}
        />
        {sidebarExpanded && sidebarContent}
      </div>
      <div className={css(styles.content)}>{children}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  expandToggle: {
    float: 'right',
    marginLeft: '16px',
  },
  paneContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  sidebar: {
    padding: '24px',
    borderRight: `1px solid ${Color.GRAY_200}`,
    minWidth: '0px',
  },
  expandedSidebar: {
    flex: 2,
  },
  content: {
    flex: 7,
  },
});
